import { AddToHomeScreen, IosShare } from '@mui/icons-material'
import { Box, Divider, Typography } from '@mui/material'
import React from 'react'
import { VBox } from '../elements/basic-elements'
import { ButtonSecondary } from '../elements/form-elements'
import CenteredModal from './modals/centered-modal'

export const HOMESCREEN_PROMPT_KEY = 'wcid_homescreen_prompt_shown'

export const shouldShowHomescreenPrompt = () => {
  if (typeof window === 'undefined') return false
  // Only on iOS Safari, not already in standalone mode
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent)
  const isStandalone =
    ('standalone' in navigator && (navigator as any).standalone === true) ||
    window.matchMedia('(display-mode: standalone)').matches
  return isIos && !isStandalone
}

const AddToHomescreenModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <CenteredModal open={open} onClose={onClose} showClose>
    <VBox gap={3} p={1} pb={2} alignItems="center" textAlign="center">
      {/* Placeholder for app preview screenshot */}
      <Box
        sx={{
          width: '100%',
          aspectRatio: '9/16',
          maxHeight: 280,
          bgcolor: 'action.hover',
          borderRadius: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1.5px dashed',
          borderColor: 'divider'
        }}
      >
        <Typography variant="body2" color="textSecondary" sx={{ opacity: 0.5 }}>
          App preview coming soon
        </Typography>
      </Box>

      <VBox gap={1}>
        <Typography variant="h5" fontWeight={600} color="textPrimary">
          Add to your home screen
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Install What Can I Do for the best experience — faster load times, push notifications,
          and a full-screen app feel.
        </Typography>
      </VBox>

      <Divider sx={{ width: '100%' }} />

      <VBox gap={1.5} width="100%" textAlign="left">
        <Typography variant="body2" color="textSecondary" fontWeight={500}>
          How to install:
        </Typography>
        <VBox gap={1}>
          <Typography variant="body2" color="textSecondary">
            1. Tap the <strong>Share</strong> button{' '}
            <IosShare sx={{ fontSize: 14, verticalAlign: 'middle' }} /> in Safari
          </Typography>
          <Typography variant="body2" color="textSecondary">
            2. Scroll down and tap <strong>"Add to Home Screen"</strong>{' '}
            <AddToHomeScreen sx={{ fontSize: 14, verticalAlign: 'middle' }} />
          </Typography>
          <Typography variant="body2" color="textSecondary">
            3. Tap <strong>"Add"</strong> to confirm
          </Typography>
        </VBox>
      </VBox>

      <ButtonSecondary onClick={onClose} fullWidth>
        Got it
      </ButtonSecondary>
    </VBox>
  </CenteredModal>
)

export default AddToHomescreenModal
